import React, { useEffect, useState }  from 'react';
import Results from '../result/Results';
import axios from 'axios';
import { useSelector } from 'react-redux';
import '../result/result_page.css';

function BucketlistPage() {

    const [bucketlists, setBucketlists] = useState([{id:-1, name:'loading'}]);
    const auth = useSelector(state => state.auth)

    useEffect(() => {
        getBucketlists();
    });

    const getBucketlists = async () => {
        const token = auth.token;
        const config = {
            headers: {
              'Content-Type': 'application/json',
            },
          };
            if (token) {
            config.headers['Authorization'] = `Token ${token}`;
          }

        axios
        .get('https://liwat-id-backend.herokuapp.com/api/bucket-list/', config)
        .then((res) => {
            const results = res.data
            const bl = results.map((result) => result.poi)
            setBucketlists(bl)
        })
        .catch((err) => {
            console.log(err)
        })
    }


    return (
        <div className="result-page" data-testid="bucketlist">
            <div className="d-flex justify-content-center">
                <p className="headline">Bucket List</p>
            </div>
            <div className="d-flex justify-content-center">
                <Results poiList={bucketlists}/>
            </div>
        </div>
    );
}

export default BucketlistPage;
